import { getField, updateField } from "vuex-map-fields";
import API from "@/api";

export const state = () => ({
  connectionsList: [],
});

export const getters = {
  getField,
  getAutocomplete: (state) => (connectionId) => {
    const connection = state.connectionsList.find(
      (connection) => connection.id === connectionId
    );
    return connection?.autocomplete;
  },
};

export const actions = {
  async getConnectionList({ commit }) {
    const response = await API.axios.get("/bff/api/v1/databases");
    if (response.status === 200) {
      response.data.forEach((connection) => {
        connection.children = [];
      });
      commit("updateField", { path: "connectionsList", value: response.data });
    }
  },

  async getConnectionTables({ commit }, { connectionId }) {
    const response = await API.axios.get(
      `/bff/api/v1/databases/${connectionId}/tables`
    );
    if (response.status === 200) {
      commit("updateConnection", { id: connectionId, children: response.data });
      commit("updateAutoComplete", {
        id: connectionId,
        children: response.data,
      });
    }
  },

  async testConnection({ dispatch }, connection) {
    return API.axios.post("/bff/api/v1/databases/test", connection);
  },

  async createConnection({ dispatch }, connection) {
    return API.axios.post("/bff/api/v1/databases/save", connection);
  },

  async clearAllConnections({ dispatch }) {
    return API.axios.delete("/bff/api/v1/databases");
  },

  async runQuery({ dispatch }, connection) {
    return API.axios.post(
      `/bff/api/v1/databases/${connection.connectionId}/query`,
      {
        query: connection.query,
      }
    );
  },
};

export const mutations = {
  updateField,
  updateConnection(state, { id, children }) {
    state.connectionsList.forEach((connection) => {
      if (connection.id === id) {
        connection.children = children;
      }
    });
  },
  updateAutoComplete(state, { id, children }) {
    const autocomplete = getAutocomplete(children);
    state.connectionsList.forEach((connection) => {
      if (connection.id === id) {
        connection.autocomplete = autocomplete;
      }
    });
  },
};

const getAutocomplete = (schemas) => {
  const autocomplete = {};
  schemas.forEach((schema) => {
    schema.children?.forEach((table) => {
      let columns = [];
      table.children?.forEach((column) => {
        columns.push(column.name);
      });
      autocomplete[`${schema.name}.${table.name}`] = columns;
    });
  });
  return autocomplete;
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
